import React from 'react'
import ScreenArticle from './screens/ScreenArticle/index'
import LayoutDefault from '../../layouts/Default'
import { Async } from 'react-async'
import fetchData from '../../modules/fetch-data'
import { withRouter } from 'react-router'
import options from '../../config/options.json'

const Article = ({ initialData, location, ...props }) => (

  <Async promiseFn={fetchData} location={location.pathname} initialValue={initialData} watch={location.pathname}>
    {({ data, error, isPending, isFulfilled }) => {
      const pianoTargets = {}
      let timeout= data && data.data && data.data.timeout

      if (isFulfilled) {
        const tags = []
        if (data.data.local !== 'undefined') tags.push(data.data.local ? 'Lokal' : 'Weltweit')
        if (data.data.plus) tags.push(options.Plus.tag)
        if (data.data.tags) tags.concat(data.data.tags)
        if (data.data.districts && data.data.districts.length > 0)
          tags.concat(data.data.districts.map((district) => district.name))
        if (data.data.editor) pianoTargets.author = data.data.editor
        if (data.data.type) pianoTargets.native = data.data.type === 'PR'
        if (data.data.type) pianoTargets.contentType = data.data.type
        if (data.data.hasVideo) pianoTargets.hasVideo = data.data.hasVideo
        if (data.data.date) pianoTargets.contentDate = data.data.date
        pianoTargets.tags = tags
      }

      return (
        <LayoutDefault
          meta={isFulfilled && data.meta}
          pianoTargets={pianoTargets}
          showAds={isFulfilled && data.data && data.data.showAds}
          {...props}
        >
          <ScreenArticle
            error={error}
            loading={isPending || timeout}
            response={isFulfilled && !timeout && data}
            ready={isFulfilled && !timeout}
            location={location}
            {...props}
          />
        </LayoutDefault>
      )
    }}
  </Async>
)

Article.getInitialData = ({ req }) => {
  return fetchData({ location: req.url })
}

export default withRouter(Article)
